/**
 * @generated SignedSource<<71767f4913768f0417eb65d92a057c52>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InviteLinkSettings_inviteCode$data = {
  readonly code: string;
  readonly id: string;
  readonly " $fragmentType": "InviteLinkSettings_inviteCode";
};
export type InviteLinkSettings_inviteCode$key = {
  readonly " $data"?: InviteLinkSettings_inviteCode$data;
  readonly " $fragmentSpreads": FragmentRefs<"InviteLinkSettings_inviteCode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InviteLinkSettings_inviteCode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    }
  ],
  "type": "InviteCode",
  "abstractKey": null
};

(node as any).hash = "2b1715ed7cccb337c41ebb30e9a8ac26";

export default node;
